import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { User } from '../interfaces/user';
import { Hotel } from '../interfaces/hotel';

interface Event {
  type: string;
  payload?: unknown;
}

type EventCallback = (payload: unknown) => void;

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private handler = new Subject<Event | null>();

  private userChangedSource = new Subject<User | null>();
  userChanged$ = this.userChangedSource.asObservable();
  private managedHotelChangedSource = new Subject<Hotel | null>();
  managedHotelChanged$ = this.managedHotelChangedSource.asObservable();

  broadcast(type: string, payload: unknown = {}): void {
    this.handler.next({ type, payload });
  }

  subscribe(type: string, callback: EventCallback): Subscription {
    return this.handler.pipe(
      filter(event => event?.type === type),
      map(event => event?.payload)
    ).subscribe(callback);
  }

  changeUser(user: User | null): void {
    this.userChangedSource.next(user);
  }

  changeManagedHotel(hotel: Hotel | null): void {
    this.managedHotelChangedSource.next(hotel);
  }
}
